import MomentUtils from '@date-io/moment';

export default class LocalizedMomentUtils extends MomentUtils {
  getWeekdays() {
    return this.moment.localeData(this.locale).weekdaysShort(true);
  }
}
